/**
 * Personalizes the given text by replacing placeholders with the provided first name and gender-specific pronouns.
 * @param {string} text
 * @param {string} firstName
 * @param {string} gender
 * @returns {string} The personalized text.
 */
// eslint-disable-next-line import/prefer-default-export
export function personalize(text, name, gender) {
  let newText = text?.toString() || '';
  const firstName = (name?.toString() || '').trim().split(' ')[0];

  if (!newText || typeof firstName !== 'string' || !firstName) {
    return newText;
  }

  let replaceNamePossessive;

  if (firstName.endsWith('s')) {
    replaceNamePossessive = `${firstName}'`;
  } else {
    replaceNamePossessive = `${firstName}'s`;
  }

  newText = newText.replace(/\b(Learner's|learner's)\b/g, replaceNamePossessive);
  newText = newText.replace(/\b(Learner|learner)\b/g, firstName);

  if (!['male', 'female'].includes(gender)) {
    return newText;
  }

  // Replace personal pronouns
  const pronounReplacements = [
    {
      regEx: /\bhe\/she\b/g,
      male: 'he',
      female: 'she',
    },
    {
      regEx: /\bhim\/her\b/g,
      male: 'him',
      female: 'her',
    },
    {
      regEx: /\bhimself\/herself\b/g,
      male: 'himself',
      female: 'herself',
    },
    {
      regEx: /\bhis\/her\b/g,
      male: 'his',
      female: 'her',
    },
    {
      regEx: /\bHe\/she\b/g,
      male: 'He',
      female: 'She',
    },
    {
      regEx: /\bHim\/her\b/g,
      male: 'Him',
      female: 'Her',
    },
    {
      regEx: /\bHimself\/herself\b/g,
      male: 'Himself',
      female: 'Herself',
    },
    {
      regEx: /\bHis\/her\b/g,
      male: 'His',
      female: 'Her',
    },
  ];

  pronounReplacements.forEach((pronoun) => {
    newText = newText.replace(pronoun.regEx, pronoun[gender]);
  });

  return newText;
}
